jQuery(document).ready(function () {
  wowo();
  textScroll();
  slider();
  scroll();
  click();
  cookie();
  date();
  contentMargin();
  appendEle();
  //video();
  /*   jQuery(window).on("load", function () {
    slider();
  }); */

  jQuery(window).scroll(function () {
    wowo();
    contentMargin();
  });
  jQuery(window).resize(function () {
    contentMargin();
  });
  /* jQuery(".product-details__info-body>p").each(function (index, dom) {
    jQuery(dom).HideMore({
      length: 164,
      showmore: " Read more...",
      hidemore: " Read less",
      replace: ""
    });
  }); */
  giveMore(".show-more ", ".product-details__info-lists ", 3, 2, 400);

  /*   jQuery('#insta-feed>a').wrapAll(function () {
      return "<div class='wrapper__ins'> </div>";
 }); */
});

function slider() {
  if (jQuery(".aussie-roasters__slider").length > 0) {
    jQuery('.aussie-roasters__slider-items:not(".slick-initialized")').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      pauseOnHover: false,
      cssEase: "linear",
      arrows: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  const featuredCollections = new Swiper(".swiper.featured-collections__items", {
    enabled: true,
    slidesPerView: 1.25,
    spaceBetween: 24,
    initialSlide: 0,
    centeredSlides: true,
    pagination: {
      enabled: true,
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 5,
    },
    breakpoints: {
      991: {
        enabled: false,
        centeredSlides: false,
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
        enabled: true,
      },
    },
  });

  const threeColCardsSwiper = new Swiper(".three-col-cards .swiper.cards", {
    enabled: true,
    slidesPerView: 1.25,
    spaceBetween: 16,
    initialSlide: 1,
    centeredSlides: true,
    pagination: {
      enabled: true,
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 5,
    },
    breakpoints: {
      991: {
        enabled: false,
        centeredSlides: false,
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
        enabled: true,
      },
    },
  });

  const cardSwiper = new Swiper(".swiper.card-carousel__items", {
    slidesPerView: 1.25,
    spaceBetween: 10,
    //loop: true,
    pagination: {
      enabled: false,
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 5,
    },
    breakpoints: {
      1200: {
        slidesPerView: 3.5,
      },
      991: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
    },
  });

  const featureBlogsSwiper = new Swiper(".swiper.feature-blogs__items", {
    slidesPerView: 1.25,
    spaceBetween: 10,
    //loop: true,
    pagination: {
      enabled: false,
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 5,
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      991: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
    },
  });

  const relatedProductsSwiper = new Swiper(".swiper.related-products__items", {
    slidesPerView: 1.25,
    spaceBetween: 10,
    //loop: true,
    pagination: {
      enabled: false,
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 5,
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      991: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
    },
  });

  const productBottomSwiper = new Swiper(".swiper.product-details__bottom", {
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
  });

  const productTopSwiper = new Swiper(".swiper.product-details__top", {
    watchSlidesProgress: true,

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 5,
    },

    thumbs: {
      swiper: productBottomSwiper,
    },
  });

  if (document.querySelector(".product-variant-id")) {
    document.querySelector(".product-variant-id").addEventListener("change", function () {
      var selectedVariantId = this.value;
      console.log(selectedVariantId);
      var mediaID = variantMediaMap[selectedVariantId];
      console.log(mediaID);
      var slides = document.querySelectorAll(".swiper-slide");
      var slideIndex = [...slides].findIndex((slide) => slide.getAttribute("data-media-id") === mediaID);
      productTopSwiper.slideTo(slideIndex);
    });
  }

  /*   if (jQuery('.product-details .product-details__top').length > 0) {

    jQuery('.product-details .product-details__top:not(".slick-initialized")').each(function () {
      if (jQuery(' .product-details__bottom .product-details__img').length > 4) {
        jQuery(this).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          // autoplay: true,
          // autoplaySpeed: 7000,
          infinite: false,
          dots: false,
          arrows: false,
          asNavFor: '.product-details__bottom',
        });
      } else {
        jQuery(this).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          // autoplay: true,
          // autoplaySpeed: 7000,
          infinite: false,
          dots: false,
          arrows: false,
        });
      }

    });
  }

  if (jQuery('.product-details .product-details__bottom').length > 0) {
    if (jQuery(' .product-details__bottom .product__media').length > 4) {
      jQuery(' .product-details__bottom:not(".slick-initialized")').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        // autoplay: true,
        // autoplaySpeed: 7000,
        infinite: false,
        dots: false,
        arrows: false,
        asNavFor: '.product-details__top',
        responsive: [

          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            }

          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 5,
            }

          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 5,
            }

          },

        ],
      });

      jQuery(".product-details .product-details__bottom .product__media").click(function () {
        var i = jQuery(this).attr('data-slick-index');
        jQuery(this).addClass('slick-current').siblings().removeClass('slick-current');
        jQuery('.product-details .product-details__top ').slick('slickGoTo', i);

      });
    }
    else {
      jQuery(".product-details .product-details__bottom .product__media").click(function () {
        console.log();
        jQuery(this).addClass('slick-current').siblings().removeClass('slick-current');
        jQuery('.product-details .product-details__top ').slick('slickGoTo', jQuery(this).index());

      });
    }


  } 

*/

  if (jQuery(".slider-logo__text").length > 0) {
    jQuery('.slider-logo__text:not(".slick-initialized")').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      // autoplay: true,
      // autoplaySpeed: 7000,
      // variableWidth: true,
      fade: true,

      nextArrow: "<button type='button' class='slick-next slick-arrow icon-right'></button>",
      prevArrow: "<button type='button' class='slick-prev slick-arrow icon-left'></button>",
      asNavFor: ".slider-logo__images",
    });
  }
  if (jQuery(".slider-logo__images").length > 0) {
    jQuery('.slider-logo__images:not(".slick-initialized")').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: false,
      // autoplay: true,
      // autoplaySpeed: 7000,
      // variableWidth: true,

      asNavFor: ".slider-logo__text",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });

    jQuery(".slider-logo__images  .slider-logo__img").click(function () {
      var i = jQuery(this).attr("data-slick-index");
      jQuery(this).addClass("slick-current").siblings().removeClass("slick-current");
      jQuery(".slider-logo__text ").slick("slickGoTo", i);
    });
  }

  var all_w = 0;
  var btnSwiper;

  function initBtnSwiper() {
    // Check if the container exists and has the proper structure
    var btnContainer = document.querySelector(".filter-btn-box .btns");
    if (!btnContainer || !btnContainer.children.length) {
      console.log("Swiper container not found or has no children");
      return;
    }

    // Ensure any previous instance is destroyed
    destroyBtnSwiper();

    try {
      btnSwiper = new Swiper(".filter-btn-box .swiper", {
        slidesPerView: "auto",
        spaceBetween: 8, // Reduced from 10 to account for margin
        loop: false,
        freeMode: {
          enabled: true,
          sticky: false,
        },
        grabCursor: true,
        draggable: true,
        //touchRatio: 1,
        //touchAngle: 45,
        //longSwipes: true,
        //longSwipesRatio: 0.5,
        //longSwipesMs: 300,
        //followFinger: true,
        allowTouchMove: true,
        simulateTouch: true,
        touchStartPreventDefault: false,

        // Enable mouse wheel support for trackpad/mouse wheel
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: true,
        },
        // Enable keyboard control
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },

        //resistanceRatio: 0.85, // Add resistance for better UX
        on: {
          init: function () {
            console.log("Swiper initialized successfully");
            //console.log("Swiper slides count:", this.slides.length);
            //console.log("Swiper wrapper:", this.wrapperEl);
            //console.log("Swiper container width:", this.width);
          },
          touchStart: function () {
            //1console.log("Touch start detected - should move now");
          },
          touchMove: function () {
            //console.log("Touch move detected - movement happening");
          },
          setTranslate: function () {
            //console.log("Swiper translate:", this.translate);
          },
        },
      });
    } catch (error) {
      console.error("Error creating Swiper instance:", error);
    }
  }

  function destroyBtnSwiper() {
    if (btnSwiper) {
      btnSwiper.destroy(true, true); // Clean up and remove event listeners
      btnSwiper = undefined;
      console.log("BTN Swiper instance destroyed");
    }
  }

  function checkBtnSwiper() {
    try {
      // Check if the filter-btn-box and its content element exist
      var filterBtnBox = jQuery(".filter-btn-box");
      if (!filterBtnBox.length) {
        destroyBtnSwiper();
        return;
      }

      var contentElement = filterBtnBox.find(".content");
      if (!contentElement.length) {
        destroyBtnSwiper();
        return;
      }

      var btnElements = filterBtnBox.find(".btns .btn");
      if (!btnElements.length) {
        destroyBtnSwiper();
        return;
      }

      // Wait for next frame to ensure layout is complete
      requestAnimationFrame(function () {
        // Calculate widths after ensuring elements exist and are rendered
        var filter_w = contentElement.width();
        var btn_w = 0;

        btnElements.each(function () {
          // Use outerWidth to include margins/padding
          var width = jQuery(this).outerWidth(true) || 0;
          btn_w += width;
        });

        console.log("Container width:", filter_w, "Total buttons width:", btn_w);

        if (filter_w < btn_w) {
          initBtnSwiper();
        } else {
          destroyBtnSwiper();
        }
      });
    } catch (error) {
      console.error("Error in checkBtnSwiper:", error);
      destroyBtnSwiper();
    }
  }

  // Use multiple methods to ensure proper initialization
  function initializeBtnSwiper() {
    // Initial check
    setTimeout(function () {
      checkBtnSwiper();
    }, 100);

    // Secondary check for slower loading content
    setTimeout(function () {
      checkBtnSwiper();
    }, 1000);

    // Final check after all resources loaded
    if (document.readyState === "complete") {
      setTimeout(checkBtnSwiper, 100);
    } else {
      window.addEventListener("load", function () {
        setTimeout(checkBtnSwiper, 100);
      });
    }
  }

  // Initialize
  initializeBtnSwiper();

  jQuery(window).resize(function () {
    // Debounce resize events
    clearTimeout(window.resizeTimer);
    window.resizeTimer = setTimeout(function () {
      checkBtnSwiper();
    }, 250);
  });
}

function wowo($) {
  setTimeout(function () {
    jQuery("html").addClass("show-c");

    var wTop = jQuery(window).scrollTop(),
      wHeight = jQuery(window).height(),
      wBottom = wTop + wHeight;
    jQuery(".wowo:not(.animated)").each(function () {
      var me = jQuery(this),
        meTop = me.offset().top,
        meHeight = me.height(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");
        setTimeout(function () {
          //me.removeClass("animated wowo");
        }, 1500);
      }
    });
    jQuery(".scroll-text").each(function () {
      var me = jQuery(this),
        meTop = me.offset().top,
        meHeight = me.height(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        setTimeout(function () {
          //me.removeClass("animated wowo");
        }, 1500);
      }
    });
  }, 100);
}

function scroll() {
  jQuery(window).scroll(function () {
    var sh = jQuery(window).scrollTop();
    var ele_H = jQuery("header").innerHeight();
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop > ele_H) {
      jQuery("header").addClass("sticky");
    } else {
      jQuery("header").removeClass("sticky");
    }
  });

  var sh = jQuery(window).scrollTop();

  var ele_H = jQuery("header").innerHeight();
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  if (scrollTop > ele_H) {
    jQuery("header").addClass("sticky");
  } else {
    jQuery("header").removeClass("sticky");
  }
}

function click() {
  jQuery(".header__hamburger ").click(function () {
    jQuery(this).toggleClass("active");
    jQuery(".header").toggleClass("is-active");
    jQuery(".header__menu").toggleClass("is-active");
    jQuery("html,body").toggleClass("overflow-h");
  });

  if (jQuery(".page-title").length > 0) {
    jQuery(".faq-block h3").click(function () {
      jQuery(this).toggleClass("active");
      jQuery(this).next().slideToggle();
      jQuery(this).siblings("h3").removeClass("active").next().slideUp();
    });
  } else {
    jQuery(".faq-block h3").click(function () {
      jQuery(this).toggleClass("active").siblings().stop().slideToggle();
      jQuery(this).parent().siblings().find("h3").removeClass("active").siblings().slideUp();
    });
  }

  jQuery(".pop-up .icon-close").click(function () {
    jQuery(".pop-up").removeClass("active");
  });

  jQuery("body").on("click", function (e) {
    if (jQuery(e.target).closest(".pop-up .content").length > 0) {
    } else {
      jQuery(".pop-up").removeClass("active");
    }
    jQuery(".product-details .select-box ").removeClass("active");
    jQuery(".product-details .select-box ").siblings().slideUp();
  });

  jQuery(".header__cart").click(function (e) {
    jQuery(".drawer").addClass("active");
    var header_H = jQuery("header").height() - 1;
    var wh = jQuery(window).height();
    var ele_h = wh - header_H;
    jQuery(".drawer ").css({
      top: header_H,
      height: ele_h,
    });

    if (jQuery("header #notification-bar").length < 1) {
      var topBar = jQuery("#notification-bar").innerHeight();
      var header_h = jQuery("header").height() - 1;
      var height = topBar + header_h;
      var ele_h = wh - height;

      jQuery(".drawer ").css({
        top: height,
        height: ele_h,
      });

      if (jQuery(".home header").hasClass("sticky")) {
        jQuery(".drawer ").css({
          top: height,
          height: ele_h,
        });
      } else {
        jQuery(".drawer ").css({
          top: 0,
          height: wh,
        });
      }
    }

    if (jQuery(".home header").hasClass("sticky")) {
      jQuery(".drawer ").css({
        top: height,
        height: ele_h,
      });
    } else {
      jQuery(".drawer ").css({
        top: 0,
        height: wh,
      });
    }
    e.stopPropagation();
  });

  jQuery(".add-shopping-cart .icon-close").click(function () {
    jQuery(".add-shopping-cart ").fadeOut();
  });

  if (jQuery(".list .select input").val() == "") {
    jQuery(".list .select").removeClass("active");
  } else {
    jQuery(".list .select").addClass("active");
  }
  jQuery(".list .select")
    .find("input")
    .blur(function () {
      jQuery(this).parent().removeClass("active");
      jQuery(this).parent().removeClass("rotate").siblings().slideUp();

      var val = jQuery(this).val();
      if (val == "") {
        jQuery(this).parent().removeClass("active");
      } else {
        jQuery(this).parent().addClass("active");
      }
    });
  jQuery(".list .select").click(function () {
    jQuery(this).toggleClass("rotate").siblings().stop().slideToggle();
  });

  jQuery("form .list ul li").click(function () {
    var text = jQuery(this).text();
    var container = jQuery(this).closest(".list");
    container.find(".select input").val(text);
    jQuery(this).parent().slideUp().siblings().removeClass("rotate");
  });

  var val = jQuery(".filter__select input").val();
  jQuery(".filter__select label").text(val);

  jQuery(".filter__select").on("click", function () {
    jQuery(this).toggleClass("active");
    jQuery(this).find("ul").stop().slideToggle();
  });
  jQuery(".filter__select ul li").click(function (e) {
    var text = jQuery(this).text();
    jQuery(".filter__select label").html(text);
    jQuery(".filter__select input").val(text);
    jQuery(this).parent().slideUp();
    jQuery(".filter__select").removeClass("active");
    e.stopPropagation();
  });

  jQuery(".product-details__according-lists .product-details__list p").click(function () {
    jQuery(this).toggleClass("active").siblings().stop().slideToggle();

    jQuery(this).parent(".product-details__list").siblings().find("p").removeClass("active").siblings().slideUp();
  });

  // jQuery(' .cart-item__quantity-wrapper button[name="minus"]').on('click', function () {
  //   var i = parseInt(jQuery(this).siblings('.quantity__input').val() - 1);
  //   if (i <= 1) {
  //     var i = 1;
  //   }
  //   jQuery(this).siblings('.quantity__input').val(i);

  // });
  // jQuery('.cart-item__quantity-wrapper button[name="plus"]').on('click', function () {
  //   var i = parseInt(jQuery(this).siblings('.quantity__input').val()) + 1;
  //   jQuery(this).siblings('.quantity__input').val(i);
  // });

  var flag = 1;
  jQuery(".form .list .icon-hide ").click(function () {
    if (flag == 1) {
      jQuery(this).siblings("input").attr("type", "text");
      jQuery(this).addClass("eye");
      flag = 0;
    } else if (flag == 0) {
      jQuery(this).siblings("input").attr("type", "password");
      jQuery(this).removeClass("eye");
      flag = 1;
    }
  });

  jQuery(".product-details .select-box ").click(function (e) {
    jQuery(this).toggleClass("active");
    jQuery(this).siblings().stop().slideToggle();
    e.stopPropagation();
  });
  jQuery(".product-details__info-select ul li").click(function (e) {
    var text = jQuery(this).text();
    jQuery(this).parent().siblings().find("label").html(text);
    jQuery(this).parent().siblings().find("input").val(text);
    jQuery(this).parent().slideUp();
    jQuery(this).parent().siblings().removeClass("active");
    e.stopPropagation();
  });
  jQuery(".show-m .header__icon").click(function () {
    jQuery(".header__logo,.header__hamburger").addClass("hidden");
    jQuery(this).addClass("flag");
  });
  jQuery(".show-m .search-modal__close-button").click(function () {
    jQuery(".header__logo,.header__hamburger").removeClass("hidden");
    jQuery(this).parents("details").find(".header__icon").removeClass("flag");
  });
  if (jQuery(".banner .btns .btn").eq(0).attr("href") == "#") {
    jQuery(".banner .btns .btn")
      .eq(0)
      .click(function () {
        console.log(1);
        var scroll_h = jQuery(this).parents(".banner").next().offset().top;
        var header = jQuery("header ").height();
        console.log(header);
        jQuery("html,body").animate(
          {
            scrollTop: scroll_h - header + 1,
          },
          800
        );
      });
  }
}

function contentMargin() {
  var header_H = jQuery("header").height() - 1;
  // var top_h = jQuery('#notification-bar').innerHeight();

  var wh = jQuery(window).height();
  var ele_h = wh - header_H;

  jQuery(".drawer ").css({
    top: header_H,
    height: ele_h,
  });

  if (jQuery(".home header").hasClass("sticky")) {
    jQuery(".drawer ").css({
      top: height,
      height: ele_h,
    });
  } else {
    jQuery(".drawer ").css({
      top: 0,
      height: wh,
    });
  }

  if (jQuery(window).width() > 991) {
    jQuery(".header__logo,.header__hamburger").removeClass("hidden");
    if (jQuery(".header__hamburger ").hasClass("active")) {
      jQuery(".header").addClass("is-active");
    } else {
      jQuery(".header").removeClass("is-active");
    }
  } else if (jQuery(".header__icon").hasClass("flag")) {
    jQuery(".header__logo,.header__hamburger").addClass("hidden");
  }

  if (jQuery("header #notification-bar").length < 1) {
    var topBar = jQuery("#notification-bar").innerHeight();
    jQuery("header").css("margin-top", topBar);
    var header_h = jQuery("header").height() - 1;
    var height = topBar + header_h;

    jQuery("body").hasClass("home") ? true : jQuery("#MainContent").css("margin-top", height);

    var ele_h = wh - height;

    jQuery(".drawer ").css({
      top: height,
      height: ele_h,
    });

    if (jQuery(".home header").hasClass("sticky")) {
      jQuery(".drawer ").css({
        top: height,
        height: ele_h,
      });
    } else {
      jQuery(".drawer ").css({
        top: 0,
        height: wh,
      });
    }
  } else {
    var ele_h = wh - header_H;
    jQuery("body").hasClass("home") ? true : jQuery("#MainContent").css("margin-top", header_H);
    setTimeout(() => {
      jQuery("body").hasClass("home") ? true : jQuery("#MainContent").css("margin-top", header_H);
    }, 300);
  }
}

function textScroll() {
  var newLeft;
  var div = jQuery(".news-ticker__scroll-box");

  var contentWidth = jQuery(".news-ticker__scroll-text").width();

  jQuery(".news-ticker__scroll-box").append("<div class='news-ticker__scroll-text'>" + jQuery(".news-ticker__scroll-text").html() + "</div> ");
  jQuery(".news-ticker__scroll-box").append("<div class='news-ticker__scroll-text'>" + jQuery(".news-ticker__scroll-text").html() + "</div> ");

  var timer = setInterval(function () {
    var contentWidth = jQuery(".news-ticker__scroll-text").width();

    var left = div.scrollLeft();
    if (left >= contentWidth) {
      div.scrollLeft(0);
      console.log(left);
    } else {
      newLeft = left;

      div.scrollLeft(newLeft + 2);
    }
  }, 20);
}

function cookie() {
  if (jQuery.cookie("open-pop-up")) {
    jQuery(".pop-up").removeClass("active");
  } else {
    setTimeout(() => {
      jQuery(".pop-up").addClass("active");
    }, 3000);
  }
  jQuery.cookie("open-pop-up", "pop-up", {
    expires: 1,
    path: "/",
  });
}

function date() {
  $('[data-toggle="datepicker"]').datepicker({
    language: "ru-RU",
  });

  var month = $('[data-toggle="datepicker"]').datepicker("getMonthName", 6, true);
}

function appendEle() {
  /* var i = parseInt(jQuery('.blog-text__main-content').children().length / 2);
  jQuery('.blog-text__subcribe-block').insertAfter(jQuery('.blog-text__main-content').children().eq(i));


  if (jQuery('.page-title').length > 0) {

    jQuery('.faq-block .content h2').each(function () {
      jQuery(this).nextUntil("h2").wrapAll(function () {
        return "<div class=' faq__content'> </div>";
      });
    });
    jQuery('.faq-block .content h3').each(function () {
      jQuery(this).nextUntil("h3").wrapAll(function () {
        return "<div class=' drop-box'> </div>";
      });
    });

  } */

  $(".product__description .read-more, .product-details__info-body .read-more").on("click", function (event) {
    event.preventDefault();
    $(this).fadeOut(300, function () {
      $(this).closest(".product__description, .product-details__info-body").find(".description-full").fadeIn(300);
      $(this).closest(".product__description, .product-details__info-body").find(".read-less").fadeIn(300);
    });
  });

  $(".product__description .read-less, .product-details__info-body .read-less").on("click", function (event) {
    event.preventDefault();
    $(this).fadeOut(300, function () {
      $(this).closest(".product__description, .product-details__info-body").find(".description-full").fadeOut(300);
      $(this).closest(".product__description, .product-details__info-body").find(".read-more").fadeIn(300);
    });
  });
}

/* (function ($) {
  $.fn.HideMore = function (options) {
    var defaults = {
      length: 12,
      showmore: "Read more...",
      hidemore: "Read less...",
      replace: ".."
    };
    var options = $.extend(defaults, options);
    var dom = $(this);
    var objhtml = dom.text();
    dom.data('fulltext', objhtml);
    dom.data('options', options);
    if (objhtml.length > options.length) {
      var precontent = objhtml.substring(0, options.length) + options.replace;
      dom.data('precontent', precontent);
      dom.html('<span>' + precontent + '</span>');
      var a = $('<a href="javascript:void(0);" class="morelink">' + options.showmore + '</a>');
      dom.append(a);
      a.on('click', function () {
        var dom_a = $(this);
        var dom_p = dom_a.parent();
        var options = dom_p.data('options');
        if (dom_a.text() == options.showmore) {
          dom_p.find('span').text(dom_p.data('fulltext'));
          dom_a.text(options.hidemore);
        } else {
          dom_p.find('span').text(dom_p.data('precontent'));
          dom_a.text(options.showmore);
        }
      });
    }
    return false;
  };
})(jQuery); */

function giveMore(button, targetUl, showNumber, loadNumber, speed) {
  undefined;
  var list = showNumber;
  var row = jQuery(targetUl);
  var sum = row.find(".product-details__info-list").hide().length;

  if (sum >= list) {
    row.find(".product-details__info-list:lt(" + list + ")").show();
  } else {
    row.find(".product-details__info-list:lt(" + list + ")").show();
  }

  jQuery(".product-details__info-step  .show-more").on("click", function () {
    $(this).fadeOut();
    // wait to prevent jerkiness in animation
    setTimeout(function () {
      undefined;
      list += loadNumber;
      row.find(".product-details__info-list:lt(" + list + ")").slideDown(speed ? speed : 400);
    }, 500);
  });
}

function video() {
  // if (Hls.isSupported()) {
  //   var videoElements = document.querySelectorAll('video');
  //   videoElements.forEach(function (videoElement) {
  //     var videoSrc = videoElement.getAttribute('src');

  //     var hls = new Hls();

  //     hls.on(Hls.Events.MANIFEST_PARSED, function () {
  //       videoElement.src = hls.url;
  // hls.loadSource(videoSrc);

  //       videoElement.play();
  //     });

  //   });
  // }

  var videoElements = document.querySelectorAll("video");

  videoElements.forEach(function (videoElement) {
    var videoSrc = videoElement.getAttribute("src");

    var hls = new Hls();

    hls.loadSource(videoSrc);

    hls.attachMedia(videoElement);
  });
}
